import React, { Component } from 'react';
import PropTypes from 'prop-types'
import Radium from 'radium';
import { semanticColors } from '../../../Globals/styles';
import { calcCompletedHours, renderOverAllocation, calcOverAllocation, sumTotalHrs } from '../../../Util/overAllocation';

class TdSummary extends Component {
  render() {
    const { children, transferredTotal, type, estimated, percentComplete, weeklySum } = this.props;
    var completedHrs = calcCompletedHours(estimated, percentComplete);
    var sum = sumTotalHrs(transferredTotal, weeklySum);
    var overAllocation = calcOverAllocation(completedHrs, sum);
    return (
      <div>
        <div style={styles.data[type]} className="col-xs-1 col-xs-offset-1">{Math.round(estimated * 10) / 10}</div>
        <div style={styles.data[type]} className="col-xs-1">{transferredTotal}</div>
        <div style={styles.data[type]} className="col-xs-1">{sum}</div>
        <div style={styles.childContainer} className="col-xs-2">
          {children}
        </div>
        <div style={styles.data[type]} className="col-xs-1">
          {completedHrs}
        </div>
        <div
          className="col-xs-1"
          style={[overAllocation < 0 && styles.danger, styles.data[type]]}>
          {/*show negative val as positive with red*/}
          {renderOverAllocation(overAllocation)} </div>
      </div>
    );
  }
}

var styles = {
  danger: {
    color: semanticColors.danger
  },
  data: {

    ROOT: {
      lineHeight: '40px',
      fontWeight: '700'
    },
    SECOND: {
      lineHeight: '40px',
      fontWeight: '600'
    },
    THIRD: {
      lineHeight: '40px'
    }
  },
  childContainer: {
    height: '39px',
    paddingRight: '0'
  }
}

TdSummary.propTypes = {
  estimated: PropTypes.number.isRequired,
  transferredTotal: PropTypes.number.isRequired,
  percentComplete: PropTypes.number.isRequired,
  weeklySum: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired
};

export default Radium(TdSummary);


// WEBPACK FOOTER //
// ./src/App/Project/WeekOverview/ActivityTable/tdSummary.jsx